<template>
    <section id="funding" style="min-height: 400px;">
        <mdb-container class="py-5">
            <mdb-row>
                <mdb-col md="6">
                    <h6 class="section-header-top">Research</h6>
                    <h2>FUNDING</h2>
                    <hr class="hr-bold"/>
                </mdb-col>
            </mdb-row>

            <mdb-row class="py-5">
                <mdb-col lg="6" md="6" class="mb-lg-0 mb-5" v-for="fund in this.$parent.funding" :key="fund.id">
                    <mdb-card class="gradient">
                        <mdb-card-body>
                            <mdb-card-title class="white-text text-uppercase"
                                            style="min-height: 200px; letter-spacing: 0.08em">{{fund.title}}
                            </mdb-card-title>
                            <div style="position: absolute;bottom: 20px;">
                                <mdb-card-text style="color: ghostwhite; font-size: 1.05em">{{fund.description}}
                                </mdb-card-text>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </mdb-col>
            </mdb-row>

        </mdb-container>
    </section>
</template>

<script>
    import {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
    } from 'mdbvue';

    export default {
        name: "Funding",
        components: {
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbCard,
            mdbCardBody, mdbCardTitle, mdbCardText,
        }
    }
</script>

<style scoped>

    .card {
        max-width: 540px;
        max-height: 150px;
        min-height: 150px
    }

    .card-img {
        max-height: 150px;
        min-height: 150px
    }

    .card-body {
        background: #778899;
        padding: 1rem !important;
        /*min-height: 150px;*/
        /*max-height: 150px;*/
    }

    .card-body-title {
        color: #FFFFFF;
        text-transform: uppercase;
        letter-spacing: 0.2em;
    }

    .card-body-text {
        letter-spacing: normal;
        text-transform: none;
        color: ghostwhite !important;
    }
</style>
